module.exports = __webpack_public_path__ + "img/change-password.3be18ce3.svg";